import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import MediatorManager from "../../../core/application/MediatorManager";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import ClickEaterFactory from "../../../core/ui/ClickEaterFactory";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import LaptopNavigateEvent from "../../../ngt/laptop/model/LaptopNavigateEvent";
import DashboardOpenerMediator from "../../dashboard/view/DashboardOpenerMediator";
import FeedbackEvent from "../../feedback/event/FeedbackEvent";
import InternalStakeholdersMediator from "../../internal-stakeholders/view/InternalStakeholdersMediator";
import KeyDecisionEvent from "../../key-decisions/event/KeyDecisionEvent";
import KeyDecisionInteractionEvent from "../../key-decisions/event/KeyDecisionInteractionEvent";
import MapFactory from "../../map/controller/MapFactory";
import MapModel from "../../map/model/MapModel";
import TeaCornerOpenerMediator from "../../tea-corner/view/TeaCornerOpenerMediator";
import TimerEvent from "../../timer/event/TimerEvent";
import TimerMediator from "../../timer/view/TimerMediator";
import HubEvent from "../event/HubEvent";
import HubKeyDecisionListMediator from "./HubKeyDecisionListMediator";
import CurrentMapChangedEvent from "../../map/event/CurrentMapChangedEvent";
import DashboardEvent from "../../dashboard/event/DashboardEvent";
import { getURLParameter } from "../../../../../lib/html5-software-library/src/ranj/util/URLUtil";
import KeyDecisionsModel from "../../key-decisions/model/KeyDecisionsModel";
import VariableManagerController from "../../../debug/modules/variablemanager/controller/VariableManagerController";
import LanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/LanguagePack";
import MapsConfig from "../../map/model/MapsConfig";
import ProgressGameModel from "../../save-game/model/ProgressGameModel";
import AnimationFactory from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import PauseOpenerMediator from "../../pause/view/PauseOpenerMediator";
import ExitOpenerMediator from "../../exit/view/ExitOpenerMediator";
import SaveGameEvent from "../../save-game/events/SaveGameEvent";
import GameClock from "../../../../../lib/html5-software-library/src/ranj/eng/story/framework/clock/GameClock";
import NGTScenarioPlayer from "../../../ngt/scenario/NGTScenarioPlayer";

export default class HubScreenMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {MediatorManager} mediatorManager 
     * @param {MapModel} mapModel 
     * @param {MapFactory} mapFactory 
     * @param {KeyDecisionsModel} keyDecisionsModel 
     * @param {VariableManagerController} variableManager 
     * @param {LanguagePack} languagePack 
     * @param {MapsConfig} mapsConfig 
     * @param {ProgressGameModel} progressGameModel 
     * @param {NGTScenarioPlayer} scenarioPlayer
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, mediatorManager, mapModel, mapFactory, keyDecisionsModel, variableManager, 
        languagePack, mapsConfig, progressGameModel, hubSaveGameModel, scenarioPlayer) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._keyDecisionsModel = keyDecisionsModel;
        this._mediatorManager = mediatorManager;
        this._mapModel = mapModel;
        this._mapFactory = mapFactory;
        this._variableManager = variableManager;
        this._languagePack = languagePack;
        this._mapsConfig = mapsConfig;
        this._progressGameModel = progressGameModel;
        this._scenarioPlayer = scenarioPlayer;

        this._hasFocus = true;

        this._queuedAvailableKeyDecisionEvents = [];

        this._chapterKeyDecisionsInitialized = 0;

        this._hubSaveGameModel = hubSaveGameModel;

        this._showSaveGameNotification = false;


    }


    initialize() {
        super.initialize();
        this.preventClickThrough();

        this._laptopMediator = this._mediatorManager.createMediator(this._target.laptopButton, SkinKeyRegistry.LAPTOP_OPENER_MEDIATOR);
        this._smartphoneMediator = this._mediatorManager.createMediator(this._target.smartphoneButton, SkinKeyRegistry.SMARTPHONE_OPENER);
        /** @type {HubKeyDecisionListMediator} */
        this._keyDecisionListMediator = this._mediatorManager.createMediator(this._target.hubTimeline.keyDecisionsContainer, SkinKeyRegistry.HUB_KEY_DECISION_LIST_SKIN);
        /** @type {InternalStakeholdersMediator} */
        this._internalStakeholdersMediator = this._mediatorManager.createMediator(this._target.internalStakeholders, SkinKeyRegistry.INTERNAL_STAKEHOLDERS);
        /** @type {TeaCornerOpenerMediator} */
        this._teaCornerOpenerMediator = this._mediatorManager.createMediator(this._target.teaCorner, SkinKeyRegistry.TEA_CORNER_OPENER);
        /** @type {TimerMediator} */
        this._timerMediator = this._mediatorManager.createMediator(this._target.timerKeyDecision, SkinKeyRegistry.TIMER);


        /** @type {PauseOpenerMediator} */
        this._pauseOpenerMediator = this._mediatorManager.createMediator(this._target.exitPauseInfoButtonScreenSkin.pauseResumeButtons, SkinKeyRegistry.PAUSE_OPENER);
        /** @type {ExitOpenerMediator} */
        this._exitOpenerMediator = this._mediatorManager.createMediator(this._target.exitPauseInfoButtonScreenSkin.exitButton, SkinKeyRegistry.EXIT_OPENER);


        /** @type {GameSavedNoticeMediator} */
        this._gameSavedNoticeMediator = this._mediatorManager.createMediator(this._target.gameSavedNoticePanel, SkinKeyRegistry.GAME_SAVED_NOTICE_MEDIATOR);

        this._replayTutorialButton = this.createButton(this._target.exitPauseInfoButtonScreenSkin.replayOnboardingButton, this._handleReplayTutorialButton.bind(this));

        this._updateMap();
        this._initializeDashboard();

        this.registerEventListener(KeyDecisionEvent.KEY_DECISION_AVAILABLE, this._handleKeyDecisionAvailable.bind(this));
        this.registerEventListener(KeyDecisionEvent.KEY_DECISION_UNAVAILABLE, this._handleKeyDecisionUnavailable.bind(this));

        this.registerEventListener(KeyDecisionInteractionEvent.CONFIRM_KEY_DECISION_SEEN, this._handleConfirmKeyDecisionSeen.bind(this));

        this.registerEventListener(LaptopNavigateEvent.LAPTOP_SHOW_REQUEST, this._handleBlur.bind(this));
        this.registerEventListener(LaptopNavigateEvent.LAPTOP_HIDE_REQUEST, this._handleFocus.bind(this));

        this.registerEventListener(TimerEvent.START_TIMER, this._handleStartTimer.bind(this));

        this.registerEventListener(HubEvent.SHOW_REQUEST, this.show.bind(this));
        this.registerEventListener(HubEvent.HIDE_REQUEST, this.hide.bind(this));

        this.registerEventListener(SaveGameEvent.SAVE_GAME, this._saveGame.bind(this));

        this.registerEventListener(HubEvent.REFRESH_KEY_DECISIONS_LIST, this._showNextQueuedAvailableKeyDecision.bind(this));

        this.registerEventListener(CurrentMapChangedEvent.CURRENT_MAP_CHANGED, this._handleCurrentMapChanged.bind(this));

        this._target.TimingBG.WeekLabel.text = "";

        //Dont hide here!. This should be driven by story (but isnt). See VideoPlayerMediator._showVideo and VideoPlayerMediator.end 
        //It seems removing the hide() call here, doesnt cause issues.
        //But hiding here is not possible irt savegame (or we must save the state of the hubscreen...)
        // this.hide();


        // DEBUG
        if (ranj.DEBUG) {
            if (getURLParameter('endgame') != null) {
                setTimeout(() => {
                    this._scenarioPlayer.stop();
                    this._variableManager.setVariable("start_arc_3_5", true);
                    this._variableManager.setVariable("arc_3_5_completed", true);
                    this._variableManager.setVariable("PATH_" + getURLParameter('endgame').toUpperCase(), true);
                    this._progressGameModel.path = getURLParameter('endgame').toLowerCase();
                    this._scenarioPlayer.play();
                }, 10000);
            }
            this._handleKeyUp = e => {
                // NB: require debug keys to require shift to be pressed at the same time
                if (!e.shiftKey) {
                    return;
                }

                var c = String.fromCharCode(e.which).toLowerCase();
                switch (c) {
                    case "f":
                        this.dispatch(FeedbackEvent.OPEN_SCREEN_REQUEST);
                        break;
                    case "d":
                        this.dispatch(DashboardEvent.OPEN_SCREEN_REQUEST);
                        break;
                    case "e":
                        this.openScreen(SkinKeyRegistry.END_SCREEN_SKIN, {
                            animationType: AnimationFactory.FADE_IN,
                            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
                        }, {
                            content: this._content,
                        });
                        break;
                    case "s":
                        this.dispatch(SaveGameEvent.SAVE_GAME);
                        break;
                    case "l":
                        this.dispatch(SaveGameEvent.LOAD_GAME);
                        break;
                    case "a":
                        console.log(this._keyDecisionsModel);
                        break;
                    case "t":
                        const clock = this._scenarioPlayer.getClock();
                        // NB: toggle between normal speed (1) and fast (20)
                        const newSpeed = clock.getSpeed() === 1 ? 20 : 1;
                        clock.setSpeed(newSpeed);
                        console.log(`[HubScreenMediator] Set clock speed to ${clock.getSpeed()}`);
                        break;
                }
            };
            window.addEventListener("keyup", this._handleKeyUp);
        }

        this.show();
        this._hubSaveGameModel.restoreHubState();
    }

    destroy() {
        super.destroy();

        this._laptopMediator.destroy();
        this._smartphoneMediator.destroy();
        this._keyDecisionListMediator.destroy();
        this._internalStakeholdersMediator.destroy();
        this._teaCornerOpenerMediator.destroy();
        this._timerMediator.destroy();
        this._dashboardOpenerMediator.destroy();
        this._pauseOpenerMediator.destroy();
        this._exitOpenerMediator.destroy();
        this._gameSavedNoticeMediator.destroy();

        this._laptopMediator = null;
        this._smartphoneMediator = null;
        this._keyDecisionListMediator = null;

        this._destroyMap();
    }

    _handleReplayTutorialButton() {
        this._tutorialScreenSkin = this.openScreen(SkinKeyRegistry.TUTORIAL_SCREEN_SKIN, {
            animationType: AnimationFactory.FADE_IN,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        });
    }

    _saveGame() {
        this._gameSavedNoticeMediator.displaySaveGame();
    }

    show() {
        this._updateCurrentLabels();
        this._initializeKeyDecisions();
        createjs.Tween.get(this._target).wait(500).to({ alpha: 1 }, 750, createjs.Ease.sineOut);
    }

    hide() {
        //To avoid issues with consecutive show and hide requests, stop any existing tween
        createjs.Tween.removeTweens(this._target);
        this._target.alpha = 0;
    }

    _updateMap() {
        this._destroyMap();

        this._mapMediator = this._mapFactory.createMap(this._target.mapContainer, this._mapModel.currentMapId);
    }

    _destroyMap() {
        if (this._mapMediator) {
            this._mapMediator.destroy();
            this._mapMediator = null;

            this._target.mapContainer.removeAllChildren();
        }
    }

    _initializeDashboard() {
        /** @type {DashboardOpenerMediator} */
        this._dashboardOpenerMediator = this._mediatorManager.createMediator(this._target.dashboardButton, SkinKeyRegistry.DASHBOARD_OPENER);
    }

    _handleKeyDecisionAvailable(evt) {
        /** @type {KeyDecisionEvent} */
        const data = evt.params.data;
        const keyDecision = data.keyDecision;

        const confirmDecisionSeenEvent = new KeyDecisionInteractionEvent(KeyDecisionInteractionEvent.CONFIRM_KEY_DECISION_SEEN, keyDecision);
        this._queuedAvailableKeyDecisionEvents.push(confirmDecisionSeenEvent);
    }

    _handleKeyDecisionUnavailable(evt) {
        /** @type {KeyDecisionEvent} */
        const data = evt.params.data;
        const keyDecision = data.keyDecision;
        this._keyDecisionListMediator.makeKeyDecisionPerformed(keyDecision);
    }

    _handleConfirmKeyDecisionSeen(evt) {
        const data = evt.params.data;
        const keyDecision = data.keyDecision;
        this._keyDecisionListMediator.makeKeyDecisionAvailable(keyDecision);
        this._showNextQueuedAvailableKeyDecision();
    }

    _handleBlur() {
        this._hasFocus = false;
    }

    _handleFocus() {
        this._hasFocus = true;
        this._updateCurrentLabels();
    }

    _showNextQueuedAvailableKeyDecision(delay = 0) {
        if (this._queuedAvailableKeyDecisionEvents.length === 0) {
            return;
        }

        const nextAvailableKeyDecisionEvent = this._queuedAvailableKeyDecisionEvents.shift();
        nextAvailableKeyDecisionEvent.delay = delay;
        this._dispatcher.dispatch(nextAvailableKeyDecisionEvent.type, { data: nextAvailableKeyDecisionEvent });
    }

    _initializeExistingKeyDecisions() {
        const completedKeyDecisions = this._keyDecisionsModel.completedKeyDecisions;
        for (let completedKeyDecision of completedKeyDecisions) {
            this._keyDecisionListMediator.makeKeyDecisionPerformed(completedKeyDecision, true);
        }


        const availableKeyDecisions = this._keyDecisionsModel.availableKeyDecisions;
        for (let availableKeyDecision of availableKeyDecisions) {
            this._keyDecisionListMediator.makeKeyDecisionAvailable(availableKeyDecision);
        }
    }

    _initializeKeyDecisions() {
        if (this._progressGameModel.chapter !== undefined && this._chapterKeyDecisionsInitialized != this._progressGameModel.chapter) {
            if (this._chapterKeyDecisionsInitialized != 0) {
                this._keyDecisionListMediator.clarKeyDecisions();
                this._keyDecisionsModel.clearKeyDecisions();
            }
            this._chapterKeyDecisionsInitialized = this._progressGameModel.chapter;
            this._keyDecisionListMediator.initializeKeyDecisions(this._keyDecisionsModel.getNumberKeyDecisionByChapter(this._progressGameModel.chapter));
            this._initializeExistingKeyDecisions();
        }
    }

    _updateCurrentLabels() {
        this._dashboardOpenerMediator.refreshIndicator();
        let chapter = "";
        if (this._progressGameModel.chapter !== undefined) {
            chapter = this._progressGameModel.chapter;
        }
        let week = "";
        if (this._progressGameModel.chapter !== undefined) {
            week = this._progressGameModel.week;
        }
        this._target.TimingBG.ChapterLabel.text = this._languagePack.getText(`hub.chapter`) + " " + chapter;
        this._target.TimingBG.WeekLabel.text = this._languagePack.getText(`hub.week`) + " " + week;
    }

    _handleStartTimer() {
        this._initializeKeyDecisions();
        this._updateCurrentLabels();
    }

    _handleCurrentMapChanged() {
        this._initializeKeyDecisions();
        this._updateCurrentLabels();
        this._updateMap();
    }
}